import http from './http.js'

/**
 * 获取 IM 登录签名（userSig）
 * 返回：{ imUserId, userSig, sdkappid }
 */
export function getUserSig() {
  return http.post('/Im/getUserSig')
}

/**
 * 获取会话列表
 * 返回：{ list: [{ from_account, avatar, nick, unread_count, last_msg }] }
 */
export function getConversationList() {
  return http.post('/Im/getConversationList')
}

/**
 * 标记会话已读
 * @param {string} conversationId - 格式如 C2Cxs_js_xxx
 */
export function doUnreadCount(conversationId) {
  // 后端要求 application/x-www-form-urlencoded 格式
  const params = new URLSearchParams()
  params.append('conversation_id', conversationId)
  return http.post('/Im/doUnreadCount', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 获取视频通话参数
 * @param {string} conversationId
 * 返回：{ is_video_chat, yy_stime, yy_etime, chains_key, store_id, user_id, iw_id }
 */
export function getVideoParam(conversationId) {
  const params = new URLSearchParams()
  params.append('conversation_id', conversationId)
  return http.post('/Im/getVideoParam', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 处理音视频问诊状态
 * @param {object} params - { ctype: 2(开始)|3(结束), iw_id?, uuid? }
 */
export function handleYyInterrogation(params) {
  return http.post('/Im/handleYyInterrogation', params)
}

/**
 * 获取历史消息（后端补充，TIM 保存有限）
 * @param {object} params - { to_account, pageindex, pagesize }
 * @returns {Promise}
 */
export function getMessageList(params) {
  return http.post('/Im/getMessageList', params)
}

/**
 * 获取协议内容
 * @param {string} classId - 协议分类 id（对应 URL 中的 protocol 参数）
 * 返回：{ data: { title, content } }（content 为 html）
 */
export function getAgreement(classId) {
  return http.post('/Index/getAgreement', { class_id: classId }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}
